export default __webpack_public_path__ + "static/media/5.46e659ec.png";